import { Record } from 'immutable';

export default class AchievementRecord extends Record({
  id: null,
  badge: null,
  createdAt: null,
  booking: null,
  description: null,
}) {
}
